export interface UserRoles {
  userId: string;
  roles: UserRole[];
}

export interface UserRole {
  name: string;
  id: string;
  organizationId: string | undefined;
  suborganizationId: string | undefined;
  leistungId: string | undefined;
  groupId: string | undefined;
  localizedDisplayName: string;
  localizedDescription: string;
  localizedCartridgeName: string | undefined;
}

export enum StaticRole {
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  LEISTUNG_ADMIN = 'LEISTUNG_ADMIN',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  ORGANIZATION_MANAGER = 'ORGANIZATION_MANAGER',
  ORGANIZATION_MEMBER = 'ORGANIZATION_MEMBER',
  DEMO_USER = 'DEMO_USER',
}

export const PLATFORM_ROLES_WITHOUT_DEMO_USER = Object.values(StaticRole).filter(key => key !== 'DEMO_USER');
export const PLATFORM_ROLES_WITH_ADMIN_RIGHTS = [
  StaticRole.PLATFORM_ADMIN,
  StaticRole.LEISTUNG_ADMIN,
  StaticRole.ORGANIZATION_ADMIN,
];

export function compareRoleWithOrganizationRoleFirst(a: StaticRole | string, b: StaticRole | string): number {
  if (getRoleValue(a, true) === getRoleValue(b, true)) {
    return a.localeCompare(b);
  }
  return getRoleValue(a, true) - getRoleValue(b, true);
}
export function compareRole(a: StaticRole | string, b: StaticRole | string): number {
  if (getRoleValue(a) === getRoleValue(b)) {
    return a.localeCompare(b);
  }
  return getRoleValue(a) - getRoleValue(b);
}

function getRoleValue(a: StaticRole | string, organizationRoleFirst = false): number {
  switch (a) {
    case StaticRole.PLATFORM_ADMIN:
      return organizationRoleFirst ? 10 : 0;
    case StaticRole.LEISTUNG_ADMIN:
      return organizationRoleFirst ? 11 : 0;
    case StaticRole.ORGANIZATION_ADMIN:
      return 2;
    case StaticRole.ORGANIZATION_MANAGER:
      return 3;
    case StaticRole.DEMO_USER:
      return 4;
    case StaticRole.ORGANIZATION_MEMBER:
      return 5;
    default:
      return 6;
  }
}

export interface RoleConfig {
  role: StaticRole;
  routeIdentifier: RegExp;
  additionalConfig: Record<string, string[]>;
}
